module.exports = __webpack_public_path__ + "static/media/cc_botao.263a7b36.webp";